// NEW_FILE_JUSTIFIED: context object split out from ThemeContext.tsx so that file exports
// only the ThemeProvider component (satisfies react-refresh/only-export-components).
import { createContext } from 'react';
import type { IThemeContext } from '@/@types/theme';

export const ThemeContext = createContext<IThemeContext | null>(null);
